class StockCallout extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (!this.els.toggle?.element) return

    this.handleToggle = this.handleToggle.bind(this)

    this.listeners.add(this.els.toggle.element, 'click', this.handleToggle)
  }

  handleToggle () {
    const initialCount = Number(this.dataset.initialItems) || 4
    const hiddenItems = this.els.grid.element.querySelectorAll(
      '.prd-StockCallout_GridItem[aria-hidden="true"]',
    )
    const isExpanded = hiddenItems.length === 0

    if (isExpanded) {
      const allItems = this.els.grid.element.querySelectorAll(
        '.prd-StockCallout_GridItem',
      )

      allItems.forEach((item, index) => {
        if (index >= initialCount) {
          item.setAttribute('aria-hidden', 'true')
        }
      })

      this.els.toggle.element.setAttribute('aria-expanded', 'false')
      this.els.moreText.element.setAttribute('aria-hidden', 'false')
      this.els.lessText.element.setAttribute('aria-hidden', 'true')
    } else {
      hiddenItems.forEach((item) => {
        item.setAttribute('aria-hidden', 'false')
      })

      this.els.toggle.element.setAttribute('aria-expanded', 'true')
      this.els.moreText.element.setAttribute('aria-hidden', 'true')
      this.els.lessText.element.setAttribute('aria-hidden', 'false')
    }
  }
}

if (!customElements.get('stock-callout')) {
  customElements.define('stock-callout', StockCallout)
}
